import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";
import { actions } from "react-redux-form";

//Auth
import { auth, db } from "./../../firebase";

//Deps
import { generateClientKey } from "./../util/keyGenerators";

function* handleSignup(action) {
  //Unpack
  const { model } = action.meta;
  if (model === "forms.signUp") {
    const {
      clientKey,
      email,
      name,
      password,
      siteId,
      apiKey
    } = action.meta.payload;

    //Set pending to false when finishehttps://www.reddit.com/r/all/top/d
    yield put(actions.setPending("forms.signUp", true));

    //Authenticate user
    let errors, isAuthenticated;
    const authClient = yield auth
      .doCreateUserWithEmailAndPassword(email, password)
      .catch(err => {
        if (err.code === "auth/email-already-in-use") {
          errors = "emailAlreadyTaken";
        }
      });

    //Set authUID and isAuthenticated for readability
    let authUID;
    if (authClient) {
      authUID = authClient.user.uid;
      isAuthenticated = true;
    }
    /*
    
    Validate Authentication, determine if User/Client
    
    */
    let cUID, hasSiteId, hasApiKey;
    let isUser, isClient, availableUsers, userCount;

    if (!isAuthenticated) {
      //Snackbar error
      if (errors === "emailAlreadyTaken") {
        yield put({
          type: ACTIONS.OPEN_SNACKBAR,
          payload: {
            variant: "info",
            message: `email already taken`
          }
        });

        //Reset pending
        yield put(actions.setPending("forms.signUp", false));
      }
    } else if (isAuthenticated) {
      /*
      
      Validate CLIENT
      
      */

      //Check and add siteId
      if (siteId) {
        hasSiteId = true;
      } else {
        hasSiteId = false;
        errors = "noSiteId";
      }

      //Check and add siteId
      if (apiKey) {
        hasApiKey = true;
      } else {
        hasApiKey = false;
        errors = "noApiKey";
      }
      /*
      
      Validate USER
      
      */
      if (clientKey !== "") {
        //Get snapshot from DB
        const clientsSnapshot = yield db
          .onceGetClients()
          .catch(err => console.log(err));

        //Check if client keys match / available users
        if (clientsSnapshot.val()) {
          // eslint-disable-next-line
          cUID = Object.keys(clientsSnapshot.val()).reduce((a, i) => {
            if (
              clientsSnapshot.val()[`${i}`].clientKey ===
              clientKey.toUpperCase()
            ) {
              a = i;
              return a;
            }
            return a;
          }, "");
        }

        //Readability
        if (cUID) {
          //Check available user count
          userCount = clientsSnapshot.val()[cUID].userCount;
          availableUsers = userCount > 0 ? true : false;

          if (!availableUsers) {
            errors = "noAvailableUsers";
          }

          //Set user flag
          isUser = true;
        }
      }

      /*
      
      Create CLIENT

      */
      if (clientKey === "" && !isUser && hasSiteId && hasApiKey) {
        isClient = true;

        //Generate clientKey
        const clientKey = generateClientKey();

        //Create Global USER
        yield db.doCreateUser(
          "self",
          authUID,
          email,
          name,
          "client",
          siteId,
          apiKey
        );

        //Create CLIENT
        yield db.doCreateClient(
          authUID,
          clientKey,
          email,
          name,
          "client",
          3,
          siteId,
          apiKey
        );
      }

      /* 
    
      Create USER
      
      */
      if (isUser && !isClient && availableUsers) {
        //Create Global USER
        yield db.doCreateUser(cUID, authUID, email, name, "user");

        //Create CLIENT USER
        yield db.doCreateClientUser(cUID, authUID, email, name, "user");

        //Update User Count
        yield db.updateUserCount(cUID, userCount - 1);
      }

      /*
    
    Handle ERRORS

    */
      console.log(errors, isClient, isUser);
      if (errors || (!isClient && !isUser)) {
        //Remove auth
        yield auth.doDeleteUser();

        //Error
        if (errors === "clientNotFound") {
          yield put({
            type: ACTIONS.OPEN_SNACKBAR,
            payload: {
              variant: "error",
              message: `client not found`
            }
          });
        } else if (errors === "noSiteId") {
          yield put({
            type: ACTIONS.OPEN_SNACKBAR,
            payload: {
              variant: "error",
              message: `no site id given`
            }
          });
        } else if (errors === "noApiKey") {
          yield put({
            type: ACTIONS.OPEN_SNACKBAR,
            payload: {
              variant: "error",
              message: `no api key given`
            }
          });
        }
      }

      /*

      Update user state REDUX
      
    */
      if (auth.getCurrentUser()) {
        //Take DB Snapshot and add to currentUser
        const userSnapshot = yield db
          .onceGetUser(authUID)
          .catch(err => console.log(err));

        yield put({
          type: ACTIONS.UPDATE_USER,
          payload: { ...userSnapshot.val(), userDataFetched: true }
        });

        //Route to dashboard
      }

      //Set pending to false when finished
      if (isAuthenticated && !errors) {
        yield put(actions.reset("forms.signUp"));
        yield put(actions.setSubmitted("forms.signUp", true));
        yield put({ type: ACTIONS.IS_AUTHENTICATED, payload: true });
      }
      yield put(actions.setPending("forms.signUp", false));
    }
  }
}

export function* signupSaga() {
  yield takeEvery(ACTIONS.SUBMIT_SIGNUP, handleSignup);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/signup.js